// extracted by mini-css-extract-plugin
module.exports = {"horizonal":"_c074f96e","buttons":"_dfdb1f5b","vertical":"_c615ed07","guide":"_e52ff1c0","image":"_dba12679","text":"_6864e33a"};